// 登录des对称加密
import CryptoJS from 'crypto-js'
import {getAccessToken, getAccountInfo, setCheckLoginInfo, setLoginInfo, setToken} from '../../util/auth'
import {checkExpired, authorize} from '../../service/getData'
import {Toast} from 'vant'

// 存localStorage
export function setLocalStorage (key, val) {
  localStorage.setItem(key, val)
}

// 取localStorage
export function getLocalStorage (key) {
  return localStorage.getItem(key)
}

// 删除localStorage
export function clearLocalStorage (key) {
  return localStorage.removeItem(key)
}

// 存cookie(cookie名,cookie值,cookie的存储时长（单位：天）)
export function setCookie (cName, value, expiredays = 30) {
  const exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  let str = (expiredays === null) ? '' : `;expires=${exdate.toGMTString()}`
  document.cookie = `${cName}=${escape(value)}${str}`
}

// 取cookie
export function getCookie (name) {
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`)
  const arr = document.cookie.match(reg)
  if (arr) {
    return (arr[2])
  } else {
    return null
  }
}

// 删除cookie
export function delCookie (name, path = '/') {
  const exp = new Date()
  exp.setTime(exp.getTime() - 1)
  const cval = getCookie(name)
  if (cval != null) {
    let str = `${name}=${cval};expires=${exp.toGMTString()}`
    if (path !== undefined) {
      str += `;path=${path}`
    }
    document.cookie = str
  }
}

// 时间类型转化
export function formatDate (dateParam, onlyDate) {
  let date = new Date(dateParam)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hour = ''
  let minute = ''
  let second = ''
  if (!onlyDate) {
    hour = date.getHours()
    minute = date.getMinutes()
    second = date.getSeconds()
  }
  return year + '-' + formatTen(month) + '-' + formatTen(day) + (!onlyDate ? (' ' + formatTen(hour) + ':' + formatTen(
    minute) + ':' + formatTen(second)) : '')
}

function formatTen (num) {
  return num > 9 ? (num + '') : ('0' + num)
}

// 时间类型转化兼容ie safri
export function formDateFn (uploadDate) {
  let data = uploadDate.substr(0, 19)
  let newDate = new Date(new Date(data.replace(/T/g, ' ').replace(/-/g, '/')).getTime() + 8 * 60 * 60 * 1000)
  let year = newDate.getFullYear()
  let month = newDate.getMonth() + 1
  month = month < 10 ? ('0' + month) : month
  let day = newDate.getDate()
  day = day < 10 ? ('0' + day) : day
  let hh = newDate.getHours()
  hh = hh < 10 ? '0' + hh : hh
  let mm = newDate.getMinutes() < 10 ? '0' + newDate.getMinutes() : newDate.getMinutes()
  let ss = newDate.getSeconds() < 10 ? '0' + newDate.getSeconds() : newDate.getSeconds()
  return year + '-' + month + '-' + day + '   ' + hh + ':' + mm + ':' + ss
}

// 时间戳转年月日 时分秒
export function formatDateTimeFn (timestamp) {
  let date = new Date(parseInt(timestamp))
  let Year = date.getFullYear()
  let Moth = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
  let Day = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
  let Hour = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours())
  let Minute = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
  let Sechond = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
  return Year + '-' + Moth + '-' + Day + '   ' + Hour + ':' + Minute + ':' + Sechond
}

// 加密
export function encryptDes (message, DES_KEY) {
  let keyHex = CryptoJS.enc.Utf8.parse(DES_KEY)
  let pwd = CryptoJS.enc.Utf8.parse(message)
  // 如果要用AES解密，就将下面这行DES改成AES 解密同理
  let encrypted = CryptoJS.AES.encrypt(pwd, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}

// 解密
export function decryptDes (message, DES_KEY) {
  let key = CryptoJS.enc.Utf8.parse(DES_KEY)
  let decrypt = CryptoJS.AES.decrypt(message, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}

// get的url参数转化为对象
export function urlObject (url) {
  const newParams = url.split('&')
  const urlObj = {}
  for (let i = 0; i < newParams.length; i++) {
    const newArray = newParams[i].split('=')
    urlObj[newArray[0]] = newArray[1]
  }
  return urlObj
}

// 复杂数组去重
export function uniqueArr (arr) {
  // 因对象特别，分出数组中的对象单独去重
  let objArr = arr.filter((item) => {
    return Object.prototype.toString.call(item) === '[object Object]'
  })
  let otherTypeArr = arr.filter((item) => {
    return Object.prototype.toString.call(item) !== '[object Object]'
  })
  // 数组及简单类型处理
  let obj = {}
  otherTypeArr = otherTypeArr.filter((item, index) => {
    let newItem = item + JSON.stringify(item)
    return obj.hasOwnProperty(newItem) ? false : (obj[newItem] = true)
  })
  // 对象类型处理
  if (objArr.length !== 0) {
    // 将数组对象转成数组字符串
    var objToStrArr = []
    var keyArr = []
    var key = ''
    var currentObj = {}
    var currentStr = ''
    objArr.forEach(item => {
      // 对象属性排序
      keyArr = []
      for (key in item) {
        keyArr.push(key)
      }
      keyArr.sort() // 降序
      currentObj = {}
      keyArr.forEach(ele => {
        currentObj[ele] = item[ele]
      })
      currentStr = JSON.stringify(currentObj)
      // 去除空格及\t空白字符
      currentStr = currentStr.replace(/(\s|[\\t])/g, '')
      objToStrArr.push(currentStr)
    })
    objToStrArr.sort()
    var tmepArr = []
    // 数组去重
    objToStrArr.forEach((item, i) => {
      if (item !== tmepArr[tmepArr.length - 1]) {
        tmepArr.push(item)
      }
    })
    var resultArr = []
    // 新数组字符串转成数组对象
    tmepArr.forEach((item) => {
      resultArr.push(JSON.parse(item))
    })
    objArr = resultArr
  }
  return [...otherTypeArr, ...objArr]
}

// 判断当前时间是否超过限制时间
// targetTime：目标时间，值是时间戳  limitDay：限制天数，值是数字
// 例如 ifOvertime(1692460800000,7)
export function ifOvertime (targetTime, limitDay) {
  let timeNum = (Date.now() - targetTime) / (1000 * 60 * 60 * 24) // 时间差天数
  if (timeNum > limitDay) {
    // 已超时
    return true
  } else {
    // 未超时
    return false
  }
}

// 检查token是否过期
export function checkExpiredFn () {
  let token = getAccessToken()
  if (token) {
    checkExpired(token).then(res => {
      if (res.code === 0) {
        if (res.data) {
          // 过期后重新登录
          loginFn()
        } else {
          // 没过期
        }
      } else {
        Toast.fail(res.msg)
      }
    })
  }
}

// token过期后，重新登录
export function loginFn () {
  let code = JSON.parse(sessionStorage.getItem('dialogCode'))
  if (code !== '' && code !== null && code !== undefined) {
    let params = {
      code,
      account: getAccountInfo()
    }
    authorize(params).then(res => {
      if (res.code === 0) {
        // 保存token
        setToken(res.data.token)
        // 保存登录信息
        setLoginInfo(res.data)
        // 保存登录验证信息
        setCheckLoginInfo(res.data)
        Toast.fail('当前token过期，已为您续期，请再次点击当前功能。')
      } else {
        this.$router.push({
          path: '/error',
          query: {
            msg: res.msg
          }
        })
      }
    })
  }
}

// 改变图片为base64格式
export function changeBaseImg (url) {
  return new Promise((resolve) => {
    const image = new Image()
    // 先设置图片跨域属性
    image.crossOrigin = 'Anonymous'
    // 再给image赋值src属性，先后顺序不能颠倒
    image.src = url
    image.onload = function () {
      const canvas = document.createElement('CANVAS')
      // 设置canvas宽高等于图片实际宽高
      canvas.width = image.width
      canvas.height = image.height
      canvas.getContext('2d').drawImage(image, 0, 0)
      // toDataUrl可以接收2个参数，参数一：图片类型，参数二： 图片质量0-1（不传默认为0.92）
      const dataURL = canvas.toDataURL('image/jpeg')
      resolve(dataURL)
    }
    image.onerror = () => {
      console.error('图片转换失败，原地址：', url)
      resolve(null)
    }
  })
}

// 附件url地址转为blob
export function fetchUrlToBlob (url) {
  return new Promise((resolve, reject) => {
    fetch(url).then(response => response.blob()).then(blob => resolve(blob)).catch(error => reject(error))
  })
}

// 将附件url地址转为blob，并下载
// 参数：url：url地址  name：附件名字  type:附件类型
export function downloadUrlToBlob (url, name, type) {
  fetchUrlToBlob(url).then(content => {
    let blob = new Blob([content])
    let date = new Date().toLocaleDateString()
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, name + date + '.' + type)
    } else {
      let elink = document.createElement('a')
      elink.download = name + date + '.' + type
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      elink.click()
    }
  }).catch(error => {
    console.error('发生错误', error)
  })
}

export default {
  setLocalStorage,
  getLocalStorage,
  clearLocalStorage,
  setCookie,
  getCookie,
  delCookie,
  formatDate,
  formDateFn,
  formatDateTimeFn,
  encryptDes,
  decryptDes,
  urlObject,
  uniqueArr,
  ifOvertime,
  loginFn,
  changeBaseImg,
  downloadUrlToBlob
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js